import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import API from "../axios";

const ExpectedResults = () => {
    const [loading, setLoading] = useState(false);
    const [selectedId, setSelectedId] = useState("");
    const [expectedResults, setExpectedResults] = useState([]);
    const [orderDatas, setOrderDatas] = useState([]);

    const loadExpectedResults = async function () {
        setLoading(true);
        const result: any = await API.getExpectedResults();
        // await loadOrders(re)

        setExpectedResults(result.data);
        setLoading(false);
    };

    const handleDelete = async function () {
        await API.deleteExpectedResult(selectedId as string);
        loadExpectedResults();
    };

    const loadOrders = async (category: string) => {
        const result: any = await API.getOrderWithCategory(category);
        setOrderDatas(result.data);
    };

    useEffect(() => {
        loadExpectedResults();
    }, []);

    return (
        <div>
            <Container style={{ marginTop: 100 }}>
                <Row>
                    <Col
                        cols="6"
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 10,
                        }}
                    >
                        <a
                            type="button"
                            className="btn btn-outline-black btn-md mx-1"
                            href={`/`}
                        >
                            <i className="bi bi-chevron-left"></i>
                        </a>
                        <h5 className="h5">Expected Results</h5>
                    </Col>
                    <Col cols="6" className="text-end">
                        <a
                            type="button"
                            className="btn btn-primary mx-1"
                            href="/create-expected-result"
                        >
                            <i className="bi bi-plus mx-2"></i>
                            Create New
                        </a>
                    </Col>
                </Row>
                {loading ? (
                    <div className="d-flex justify-content-center my-5">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                ) : (
                    <table className="table table-striped mt-3">
                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col">Key</th>
                                <th scope="col">Structure</th>
                                <th scope="col">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {expectedResults.map(
                                (result: any, index: number) => (
                                    <tr key={index}>
                                        <td>{result.name}</td>
                                        <td>{result.key}</td>
                                        <td>
                                            {result.json ? Object.keys(result.json).length : "0"}{" "}
                                            Fields
                                        </td>
                                        <td>
                                            <div className="d-grid gap-2 d-md-block">
                                                <a
                                                    type="button"
                                                    className="btn btn-outline-primary btn-sm mx-1"
                                                    href={`/expected-result/${result._id}`}
                                                >
                                                    <i className="bi bi-pencil"></i>
                                                </a>
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-danger btn-sm mx-1"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#deleteModal"
                                                    onClick={() => {
                                                        setSelectedId(
                                                            result._id
                                                        );
                                                    }}
                                                >
                                                    <i className="bi bi-trash"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            )}
                        </tbody>
                    </table>
                )}
            </Container>

            {/* Delete Dialog */}
            <div
                className="modal fade"
                id="deleteModal"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1
                                className="modal-title fs-5"
                                id="staticBackdropLabel"
                            >
                                Confim To Delete
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <p>
                                You are going to delete this record. Are you
                                sure?
                            </p>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger"
                                data-bs-dismiss="modal"
                                onClick={handleDelete}
                            >
                                <i className="bi bi-trash mx-2"></i>
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExpectedResults;
